(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TrowelCollapses", [], factory);
	else if(typeof exports === 'object')
		exports["TrowelCollapses"] = factory();
	else
		root["TrowelCollapses"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition